import { useBooleanState, useEventCallback } from '@cian/react-utils';
import { useLocalStorage } from 'usehooks-ts';

export function useUnavailableProgramModal() {
  const { state: isModalOpen, setTrue: openModal, setFalse: closeModal } = useBooleanState(false);
  const [hasSeenModal, setHasSeenModal] = useLocalStorage('hasSeenModal', false);

  const openUnavailableProgramModal = useEventCallback(() => {
    openModal();
    setHasSeenModal(true);
  });

  return {
    hasSeenUnavailableProgramModal: hasSeenModal,
    isUnavailableProgramModalOpen: isModalOpen,
    openUnavailableProgramModal,
    closeUnavailableProgramModal: closeModal,
  };
}
